import React from 'react';


const RewardTable = ({ data }) => {
  

  return (
    (
        <table className="max-w-1/2  bg-white border border-gray-300 m-6">
            <thead className="bg-gray-200">
                <tr>
                    <th className="py-1 px-2 sm:px-4 text-center">DATE</th>
                    <th className="py-1 px-2 sm:px-4 text-center">REWARD TYPE</th>
                    <th className="py-1 px-2 sm:px-4 text-center" rowSpan="2">CASHBACK<br />PERCENTAGE</th>
                    <th className="py-1 px-2 sm:px-4 text-center">MERCHANT</th>
                    <th className="py-1 px-2 sm:px-4 text-center">TIME</th>
                    <th className="py-1 px-2 sm:px-4 text-center">CARD INFO</th>
                    <th className="py-1 px-2 sm:px-4 text-center">AMOUNT SPENT</th>
                    <th className="py-1 px-2 sm:px-4 text-center">CASHBACK REWARD</th>
                </tr>
            </thead>
            <tbody>
                {data.map((reward, index) => (
                    <tr key={reward.id} className={`${index % 2 === 0 ? 'bg-gray-100' : ''}`}>
                        <td className="py-1 px-2">{reward.date}</td>
                        <td className="flex items-center justify-start my-3 py-2 px-6"><img src={reward.img} alt={reward.rewardType} className="w-6 h-6 mr-2"/>{reward.rewardType}</td>
                        <td className="text-center py-4 px-2">{reward.cashbackPercent * 100}%</td>
                        <td className="text-center py-4 px-2">{reward.merchant}</td>
                        <td className="text-center py-4 px-2">{reward.time}</td>
                        <td className="text-center py-4 px-2">{reward.cardInfo}</td>
                        <td className="text-center py-4 px-2">${reward.amountSpent.toFixed(2)}</td>
                        <td className="text-center py-4 px-6 text-green-600 font-semibold">${(reward.amountSpent * reward.cashbackPercent).toFixed(2)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
   
  )
}

export default RewardTable